import type { FunctionComponent } from 'react';

import type { SvgProps } from './types';

export const AbbSearch: FunctionComponent<SvgProps> = ({ fill = '#1f1f1f', size = 14, ...props }) => {
  return (
    <>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width={size} height={size} fill={fill} {...props}>
        <g id='Box'>
          <rect fill='none' width={size} height={size} />
        </g>
        <g id='Final_icons_-_Common' data-name='Final icons - Common'>
          <path d='M22,20l-6.31-6.31A7.48,7.48,0,1,0,4.18,14.82,7.42,7.42,0,0,0,9.45,17a7.54,7.54,0,0,0,4.24-1.31L20,22ZM5.59,13.41A5.54,5.54,0,0,1,9.55,4a5.44,5.44,0,0,1,3.86,1.59,5.53,5.53,0,0,1-7.82,7.82Z' />
        </g>
      </svg>
    </>
  );
};
